<span *ngIf="lesson.type === 'seminar'" class="priority-edit">
  <i class="icon-btn material-icons" (click)="changePriority(-1)">keyboard_arrow_up</i>
  <input class="priority" [(ngModel)]="priority" (change)="setPriority(+$event.target.value)">
  <i class="icon-btn material-icons" (click)="changePriority(1)">keyboard_arrow_down</i>
</span>
<i *ngIf="!lesson.hidden" class="icon-btn material-icons" (click)="changeVisibility(!lesson.hidden)">visibility_on</i>
<i *ngIf="lesson.hidden" class="icon-btn material-icons" (click)="changeVisibility(!lesson.hidden)">visibility_off</i>
